import React from 'react';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { Button } from '../../../_shared/components/Button/Button';
import { StatusLabel } from '../../../_shared/components/StatusLabel/StatusLabel';
import { ReactComponent as XlsxIcon } from '../../../_shared/assets/icons/xlsx-icon.svg';
import styles from './PlanningHeader.module.scss';

interface Props {
  year: number;
  status: string;
  startDate: string;
  fillDeadline: string;
  approvalDeadline: string;
  onReportClick?: () => void;
}

export function PlanningHeader({
  year,
  status,
  startDate,
  fillDeadline,
  approvalDeadline,
  onReportClick
}: Props) {
  return (
    <div className={styles.header}>
      <Typography variant="h1">Планирование на {year} год</Typography>
      <div className={styles.meta}>
        <div className={styles.metaItem}>
          <Typography variant="caption">Статус кампании</Typography>
          <StatusLabel variant="info">{status}</StatusLabel>
        </div>
        <div className={styles.metaItem}>
          <Typography variant="caption">Старт кампании</Typography>
          <Typography variant="text">{startDate}</Typography>
        </div>
        <div className={styles.metaItem}>
          <Typography variant="caption">Дедлайн заполнения KPI</Typography>
          <Typography variant="text">{fillDeadline}</Typography>
        </div>
        <div className={styles.metaItem}>
          <Typography variant="caption">Согласование</Typography>
          <Typography variant="text">{approvalDeadline}</Typography>
        </div>
        {onReportClick && (
          <Button
            variant="secondary"
            className={styles.reportButton}
            onClick={onReportClick}
          >
            Посмотреть отчёт
            <XlsxIcon />
          </Button>
        )}
      </div>
    </div>
  );
}
